'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            color: theme.color,
            fontSize: theme.fonSize,
            lineHeight: theme.lineHeight,
            textAlign: theme.textAlign,
            paddingBottom: theme.paddingBottom,
            paddingTop: theme.paddingTop,
            width: theme.width,
            minWidth: theme.minWidth,

            '& a': {
                color: theme.linkColor
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        color: theme.tLabel,
        linkColor: theme.tAccent,
        fonSize: theme.tsXSmall,
        lineHeight: theme.tlXSmall,
        paddingBottom: 0,
        paddingTop: theme.gutter + 'px',
        textAlign: 'left',
        width: 'auto',
        minWidth: 'auto'
    };
};